import { createApp } from 'vue'
import Regl from './Regl.vue'
import './assets/global.css'

createApp(Regl).mount('#regl')
